import script from "./SharedBoxModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBoxModal.vue?vue&type=script&setup=true&lang=js"

import "./SharedBoxModal.vue?vue&type=style&index=0&id=4f1d3f1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1d3f1e"]])

export default __exports__